import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { JurisdictionsTable } from './JurisdictionsTable'
import { JurisdictionsSearch } from './JurisdictionsSearch'
import { JurisdictionsFilters } from './JurisdictionsFilters'
import { useJurisdictionsContextValue } from '../context/JurisdictionsProvider'

const JurisdictionsHeader = () => {
  const { state, actions } = useJurisdictionsContextValue()

  return (
    <Header
      title="Jurisdictions"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
        </Flex>
      }
    />
  )
}

export const JurisdictionsMain = () => {
  return (
    <>
      <JurisdictionsHeader />
      <Box margin={3}>
        <JurisdictionsSearch />
        <JurisdictionsFilters />
        <JurisdictionsTable />
      </Box>
    </>
  )
}
